import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { Observable, Subject, map, take, tap } from 'rxjs';
import { AllStatus } from '../../../core/services/status/all-status';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface IKit{
  card_kit_id: number,
  name: string,
  is_default: boolean,
  data: {
    humman_description:{
      title: string,
      text: string,
      [propName: string]: any
    }
  },
  difficulty_levels: Array<string>,
  [propName: string]: any
}

export interface IQuestRequest{
  rq_id: number,
  name: string,
  type: string,
  is_custom: boolean,
  is_newbie: boolean,
  icon: string,
  icons: Array<string>,
  data: {
    humman_description:{
      title: string,
      text: string,
      goal: string,
      [propName: string]: any
    },
    questionnaire: Array<number>,
    [propName: string]: any
  },
  card_kits: Array<IKit>,
  [propName: string]: any
}

export interface IRequestQuest{
  quest: Array<IQuestRequest>
}

export interface IQuest{
  rq_id: number,
  name: string,
  type: string,
  is_custom: boolean,
  is_newbie: boolean,
  icon: string,
  icons: Array<string>,
  data: {
    humman_description:{
      title: string,
      text: string,
      [propName: string]: any
    },
    questionnaire: Array<number>,
    [propName: string]: any
  },
  card_kits: Array<IKit>,
  [propName: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class ListQuest {

  http = inject(HttpClient);
  backend = inject(BackendService);
  destroyRef = inject(DestroyRef);
  readonly questsUpdated$ = new Subject<void>();
  quests: Array<IQuestRequest>;
  allStatus = inject(AllStatus);
  quest: IQuest;

  constructor() { }

  getAllQuests(){
    const isQuest = !!sessionStorage.getItem("questsAll");
    if(isQuest){
      
      this.quests = JSON.parse(sessionStorage.getItem("questsAll") as string); 
      this.questsUpdated$.next();
      this.allStatus.setSelectRQ(this.quests[0].rq_id);
      this.allStatus.setLoadRQ(true);
    }else{
      
      this.http.get<IRequestQuest>(`${this.backend.getApiUrl()}/quests`).pipe(
        tap((jsonQuest: IRequestQuest) => {
          this.quests = jsonQuest.quest;
          this.saveStorage();
          this.questsUpdated$.next();
        })
      ).subscribe();
    }
  }

  getChangeLanguageAllQuests(): Observable<void>{
    return this.http.get<IRequestQuest>(`${this.backend.getApiUrl()}/quests`).pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((jsonQuest: IRequestQuest) => {
            this.allStatus.setLoadRQ(true);
            this.quests = jsonQuest.quest;
            this.allStatus.setSelectRQ(this.allStatus.selectRQ.value); 
            this.listRestructuring(this.allStatus.selectRQ.value);
            this.questsUpdated$.next();
        }),
        map(() => undefined)
      );
  }

  getAllQuestsByLobby(): Observable<void>{
    this.quests = [];
    return this.http.get<IRequestQuest>(`${this.backend.getApiUrl()}/quests`).pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((jsonQuest: IRequestQuest) => {
          this.quests = jsonQuest.quest; 
          this.listRestructuring(this.allStatus.selectRQ.value);
          this.questsUpdated$.next();
          //this.saveStorageByLobby();
        }),
        map(() => undefined)
      );
  }

  saveStorage(){
    sessionStorage.setItem('questsAll', JSON.stringify(this.quests));
    this.allStatus.setSelectRQ(this.quests[0].rq_id);
    this.allStatus.setLoadRQ(true);
    this.allStatus.setDisplayProgressSpinner(false);
  }

  saveStorageByLobby(){
    sessionStorage.setItem('questsAll', JSON.stringify(this.quests));
  }

  clearStorage(){
    this.allStatus.setSelectRQ(0);
    sessionStorage.removeItem('questsAll'); 
  }

  questInfo(rq_id: number){
    return this.http.get(`${this.backend.getApiUrl()}/quests/${rq_id}`).pipe(
      tap( (result: any) => sessionStorage.setItem("QuestInfo", JSON.stringify(result.quest)) ),
      take(1)
    );
  }

  findQuest(id: number):IQuestRequest{
    return this.quests.find((item: IQuestRequest)=> item.rq_id === id) as IQuestRequest;
  }

  removeElement(rq_id: number): void{
    this.quests = this.quests.filter((item: IQuestRequest) => item.rq_id !== rq_id);
  }

  listRestructuring(rq_id: number): void{
    let first: IQuestRequest = this.findQuest(rq_id);
    this.removeElement(rq_id);
    this.quests.unshift(first);
    this.saveStorageByLobby();
  }
}
